import { render } from "./ChatsList.vue?vue&type=template&id=44b8e0ef&scoped=true"
import script from "./ChatsList.vue?vue&type=script&lang=js"
export * from "./ChatsList.vue?vue&type=script&lang=js"

import "./ChatsList.vue?vue&type=style&index=0&id=44b8e0ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b8e0ef"]])

export default __exports__